import { IconProps } from '@/assets/types/icon'

const FacebookLogo = ({ className, ...props }: IconProps) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M31.9978 16.0006C31.9978 24.0816 26.0078 30.7623 18.2265 31.8464C17.4989 31.9473 16.7545 32 15.9989 32C15.1267 32 14.2702 31.9305 13.4361 31.796C5.81839 30.5695 0 23.9638 0 16.0006C0 7.16392 7.16368 0 16 0C24.8363 0 32 7.16392 32 16.0006H31.9978Z"
        fill="#7D7D7D"
      />
      <path
        d="M18.2265 12.848V16.3335H22.5381L21.8554 21.0288H18.2265V31.8464C17.4989 31.9473 16.7545 32 15.9989 32C15.1267 32 14.2702 31.9305 13.4361 31.796V21.0288H9.45966V16.3335H13.4361V12.0688C13.4361 9.42298 15.5807 7.27716 18.2276 7.27716V7.27941C18.2354 7.27941 18.2422 7.27716 18.25 7.27716H22.5393V11.3378H19.7366C18.9036 11.3378 18.2276 12.0139 18.2276 12.8469L18.2265 12.848Z"
        fill="white"
      />
    </svg>
  )
}

export default FacebookLogo
